module.exports = __webpack_public_path__ + "img/calendar.a69e341a.png";